var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257 787L257 815",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.5,
    cy: 782.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.987 782.19C252.987 778.283 256.288 775.117 260.358 775.117C260.943 775.117 261.511 775.184 262.056 775.308C260.742 774.48 259.187 774 257.519 774C252.814 774 249 777.806 249 782.5C249 787.194 252.814 791 257.519 791C259.814 791 261.895 790.093 263.427 788.62C262.492 789.032 261.454 789.263 260.358 789.263C256.288 789.263 252.987 786.096 252.987 782.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.402 781.6L266.37 779.146L264.536 780.719L262.304 780.056L263.112 782.337L261.765 784.381L264.1 784.218L265.499 786.144L266.133 783.763L268.345 782.909L266.402 781.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.29cb695acfaba6ea24699b14d87cf771.svg";
export { ForwardRef as ReactComponent };